import Vue from "vue"
import { Component, Prop, Watch, Ref } from "vue-property-decorator"
import { CustomerTypeEnum } from "../../../../../../Scripts/inpulse/CommonEnums";
import { IContractSettings } from "../../../new-contract-vuex-store";
import { IContractViewModel } from "../../../../../../Scripts/inpulse/I4UViewModels";
import NewContractStore from "../../../new-contract-vuex-store";
@Component({
})

export default class ProductionType extends Vue {
    @Prop()
    priceListId: number;

    @Prop({default: false})
    isSelectedPriceList: boolean;

    get contractSettings(): IContractSettings { return this.$store.state.contractSettings; }
    get contract(): IContractViewModel { return this.$store.state.contract; }
    get isPriima(): boolean {
        return this.contractSettings.PriimaProductId && this.contractSettings.PriimaProductId > 0
            && this.contract.ProductId == this.contractSettings.PriimaProductId;
    }
    get isPriimaPlus(): boolean {
        return this.contractSettings.PriimaPlusProductId && this.contractSettings.PriimaPlusProductId > 0
            && this.contract.ProductId == this.contractSettings.PriimaPlusProductId;
    }
    get offerRequest(): boolean { return this.$store.state.offerRequest; }
    constructor() {
        super();        
    }

    mounted() {
        this.initTypes();
    }
    selected: string = '1';

    @Watch("selected")
    newSelection() {
        if (this.contract.PriceListId == this.priceListId) {
            this.selectedPriceListChanged();
        }
    }

    @Watch("isSelectedPriceList")
    selectedPriceListChanged() {
        if (this.contract.PriceListId == this.priceListId) {
            let hasSelection: boolean = this.selected != null;
            let isCompany: boolean = this.contract.CustomerType == CustomerTypeEnum.COMPANY;
            let price: number;
            let priceConsumer: number = 0.10;
            let priceCompany: number = 0.0806;
            switch (this.selected) {
                case 'Sekasähkö':
                case 'Pörssisähkö': {
                    price = 0;
                    break;
                }
                case 'Tuulivoima':
                case 'Vesivoima': {
                    price = isCompany ? priceCompany : priceConsumer;
                    break;
                }
                default:
                    break;
            }

            let current_ef_choise: string;
            let el = this.contract.ExtraFeatures.find(e => e.Name == "Pörssisähkö" || e.Name == "Sekasähkö" || e.Name == "Tuulivoima" || e.Name == "Vesivoima");
            if (el) {
                current_ef_choise = el.Name;
            }
            if (hasSelection) {
                if (current_ef_choise && current_ef_choise != this.selected) {
                    return this.$store.dispatch("removeAndUpdateExtraFeature", { originalname: current_ef_choise, name: null, amount: 0, price: 0 }).then(() => {
                        this.$store.dispatch("updateExtraFeature", { name: this.selected, amount: 1, price: price });
                    });
                }
                if (!current_ef_choise) {
                    return this.$store.dispatch("updateExtraFeature", { name: this.selected, amount: 1, price: price });
                }
                if (current_ef_choise && current_ef_choise == this.selected) {
                    return this.$store.dispatch("updateExtraFeature", { name: this.selected, amount: 1, price: price });
                }
            }
            else {
                if (current_ef_choise) {
                    return this.$store.dispatch("removeAndUpdateExtraFeature", { originalname: current_ef_choise, name: null, amount: 0, price: 0 });
                }
            }
        }
        if (this.contract.PriceListId > 0 && this.contract.PriceListId != this.priceListId) {
            this.selected = null;
            if (!this.isPriimaPlus && !this.isPriima) {
                let el = this.contract.ExtraFeatures.find(e => e.Name == "Sekasähkö" || e.Name == "Tuulivoima" || e.Name == "Vesivoima");
                if (el) {
                    return this.$store.dispatch("removeAndUpdateExtraFeature", { originalname: el.Name, name: null, amount: 0, price: 0 });
                }
            }
        }

    };

    data() {
        const priceConsumer: string = '0,10'
        const priceCompany: string = '0,0806'

        return {
            selected: this.selected ? this.selected : null,
            optionsConsumer: [
                { text: this.$t('Sekasähkö + 0,00 snt/kWh'), value: 'Sekasähkö' },
                { text: this.$t('Tuulivoima + ' + priceConsumer + ' snt/kWh'), value: 'Tuulivoima' },
                { text: this.$t('Vesivoima + ' + priceConsumer + ' snt/kWh'), value: 'Vesivoima' }
            ],
            optionsCompany: [
                { text: this.$t('Sekasähkö + 0,00 snt/kWh'), value: 'Sekasähkö' },
                { text: this.$t('Tuulivoima + ' + priceCompany + ' snt/kWh'), value: 'Tuulivoima' },
                { text: this.$t('Vesivoima + ' + priceCompany + ' snt/kWh'), value: 'Vesivoima' }
            ],
        };

    }

    initTypes(): void {
        if (this.contract.PriceListId == this.priceListId) {
            for (var i = 0; i < this.contract.ExtraFeatures.length; i++) {
                let efName = this.contract.ExtraFeatures[i].Name;
                if (efName == "Pörssisähkö" || efName == "Sekasähkö" || efName == "Tuulivoima" || efName == 'Vesivoima') {
                    this.selected = efName;
                }
            }
        }
    }
}
